import React, {useState, useEffect} from "react";

// STYLES 
import './css/alertMessage.css';

// ASSETS
import Logo from '../../assets/Logo.png';



export const AlertMessage = ({TITLE, TEXT}) => {

    return (
        <div>
            <div className="overflow"></div>
            
            <section className="alert-area">
                <h1 className="title-alert">{TITLE}</h1>
                <p className="text-alert">{TEXT}</p>
                <img src={Logo} className="logo-img" alt={'SofChef'}/>
            </section>
        </div>
    )
}
